import React, { PureComponent } from 'react';

import './ViewDiamondPage.style';
import "../ProductPage/ProductPage.style.scss";
import StepSection from 'Component/StepSection';
import ContentWrapper from '@scandipwa/scandipwa/src/component/ContentWrapper';
import DiamondImageGallery from 'Component/DiamondImageGallery';
import TextPlaceholder from '@scandipwa/scandipwa/src/component/TextPlaceholder';
import { TextPlaceHolderLength } from '@scandipwa/scandipwa/src/component/TextPlaceholder/TextPlaceholder.config';
import { GQLCurrencyEnum } from '@scandipwa/scandipwa/src/type/Graphql.type';
import { isCrawler, isSSR } from '@scandipwa/scandipwa/src/util/Browser';
import history from '@scandipwa/scandipwa/src/util/History';
import diamond_Shape from 'Src/Value/Diamond_shape';
import { custmizesku } from 'Src/Value/customization';
import NoMatch from '@scandipwa/scandipwa/src/route/NoMatch';
import ProductShippingCardInfo from 'Component/ProductShippingCardInfo';
import FreeGiftOption from 'Component/FreeGiftOption';
import DiamondInfoDetailPage from 'Component/DiamondInfoDetailPage';
import DiamondDetails from 'Component/DiamondDetails';
import DiamondDetailsContent from 'Component/DiamondDetailsContent';
import { color_diamonds } from 'Src/Value/ColorDiamond_color';

export class ViewDiamondPage extends PureComponent {
    static propTypes = {
        diamond: this.propTypes,
        isLoading: this.propTypes,
        device: this.propTypes
    };

    state = {
        ringsetting: JSON.parse(localStorage.getItem("setting")),
        ringdiamond: JSON.parse(localStorage.getItem("diamond")),
        scroll: false,
        showFinanceOptions: true
    };

    renderImagePlaceHolder = () => {
        return (
            <div className='ProductCard-Image-Placeholder' />
        )
    }

    renderProductName() {
        const {
            diamond,
            isLoading
        } = this.props;

        const parts = [];

        if (isLoading) {
            return (
                <h1 className='ProductPage-Title'>
                    <TextPlaceholder length={TextPlaceHolderLength.LONG} />
                </h1>
            )
        }

        if (diamond[0].diamond_carat) {
            parts.push(`${diamond[0].diamond_carat} carat`);
        }

        if (diamond[0].diamond_shape) {
            parts.push(`${diamond[0].diamond_shape} diamond`);
        }

        if (diamond[0].diamond_color) {
            parts.push(`color-${diamond[0]?.hasColor ? color_diamonds[diamond[0]?.diamond_color?.toLowerCase()] : diamond[0].diamond_color}`);
        }

        if (diamond[0].diamond_clarity) {
            parts.push(`clarity-${diamond[0].diamond_clarity}`);
        }

        if (diamond[0].diamond_cut) {
            parts.push(`cut-${diamond[0].diamond_cut}`);
        }

        if (diamond[0].diamond_certificate) {
            parts.push(`${diamond[0].diamond_certificate} certified`);
        }

        const diamond_name = parts.join(', ');

        return (
            <h1 className='ProductPage-Title'>
                {diamond[0]?.diamond_created_from === "Lab-Grown" ? "lab created " : ""} {diamond_name}
            </h1>
        );
    }

    renderProductStocknumber() {
        const {
            diamond,
            isLoading
        } = this.props;

        if (isLoading) {
            return (
                <h1 className='ProductPage-Stocknumber'>
                    <TextPlaceholder length={TextPlaceHolderLength.MEDIUM} />
                </h1>
            )
        }

        return (
            <h1 className='ProductPage-Stocknumber'>
                {`Stock Number: ${diamond[0].diamond_sku}`}
            </h1>
        )
    }

    renderShippingTime = () => {
        return (
            <ProductShippingCardInfo />
        )
    }

    renderPrice() {
        const {
            diamond,
            isLoading
        } = this.props;

        if (isLoading) {
            return (
                <div>
                    <TextPlaceholder length={TextPlaceHolderLength.SHORT} />
                </div>
            )
        }

        const currencySymbol = GQLCurrencyEnum.USD;

        const pricewithcurrency = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currencySymbol,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(Math.round(diamond[0].diamond_price).toFixed(0));

        return (
            <div className="ProductPage-PriceWrapper">
                <span className="ProductPage-Custmization">Diamond Only</span>
                <div className="ProductPagePrice-PriceComponent">
                    <div className="ProductPagePrice-FinalPrice">
                        <span>{pricewithcurrency}</span>
                    </div>
                </div>
            </div>
        )
    }

    onlyOneAvaliable() {
        const {
            isLoading
        } = this.props;

        if (isLoading) {
            return (
                <div>
                    <TextPlaceholder length={TextPlaceHolderLength.MEDIUM} />
                </div>
            )
        }

        return (
            <div className="Diamond-Only-One-Avaliable">
                <span>Only One Available</span>
            </div>
        )
    }

    getFinalProductLink = (custmizefinalsku) => {
        switch (custmizefinalsku) {
            case custmizesku?.finalring?.sku:
                return custmizesku?.finalring?.url
            case custmizesku?.finalpendant?.sku:
                return custmizesku?.finalpendant?.url
            default:
                return custmizesku?.finalring?.url
        }
    }

    getCustmizeProductLink = (ringsetting) => {
        if (ringsetting) {
            const { categories } = ringsetting;

            const categoryCustomization_info = categories ? categories[categories.length - 1]?.customization_info : "";

            const diamond_link = categoryCustomization_info?.diamond_link;
            const setting_link = categoryCustomization_info?.setting_link;
            const custmizefinalsku = categoryCustomization_info?.final_sku;
            const finalproductlink = this.getFinalProductLink(custmizefinalsku);

            return { finalproductlink, diamond_link, setting_link };
        }

        return {
            finalproductlink: `${custmizesku.finalring.url}`,
            diamond_link: "/customize/ring-diamond/natural-diamond.html?diamond_created_from=11",
            setting_link: "/customize/ring-settings.html"
        }
    }

    handleSelectOption = () => {
        const {
            diamond
        } = this.props;

        const step = localStorage.getItem("step");
        const ringsetting = JSON.parse(localStorage.getItem("setting"));
        let diamondDetails = { ...diamond[0] };

        const ShapeCode = diamond_Shape.filter((value) => {
            return value.label === diamondDetails?.diamond_shape;
        });

        if (ShapeCode?.length > 0) {
            diamondDetails = { ...diamondDetails, diamond_Shape_code: ShapeCode[0]?.code };
        }

        let finalsettingid;
        let finaldiamondid;
        let finalproductsettingid;

        finaldiamondid = diamond[0]?.diamond_sku;

        const custmizelink = this.getCustmizeProductLink(ringsetting);
        let selectedoption_obj = {};

        if (ringsetting) {
            selectedoption_obj = Object.fromEntries(ringsetting?.selectedcustomoptions);

            const attribute_values = ringsetting?.attributes?.shape?.attribute_options ? Object.keys(ringsetting?.attributes?.shape?.attribute_options) : [];
            const { variants } = ringsetting;

            if (ShapeCode?.length > 0) {
                if (!(selectedoption_obj.shape === ShapeCode[0].code)) {
                    if (attribute_values?.length > 0) {
                        const hasmatch = attribute_values?.some((shape) => (
                            shape === ShapeCode[0].code
                        ))

                        if (hasmatch) {
                            selectedoption_obj.shape = ShapeCode[0].code;
                            localStorage.setItem("setting", JSON.stringify({ ...ringsetting, selectedcustomoptions: Object.entries(selectedoption_obj) }));
                        }
                    }
                }
            }

            if (variants?.length > 0) {
                const data = variants?.filter(function (item) {
                    for (var key in selectedoption_obj) {
                        if (item.attributes[key]) {
                            if (item.attributes[key].attribute_value === undefined || item.attributes[key].attribute_value != selectedoption_obj[key])
                                return false;
                        }
                    }
                    return item;
                });

                if (data?.length > 0) {
                    finalsettingid = btoa(data[0]?.id);
                    finalproductsettingid = btoa(ringsetting?.id);
                } else {
                    finalsettingid = ringsetting?.id;
                    finalproductsettingid = btoa(ringsetting?.id);
                }
            }
        }

        localStorage.setItem("diamond", JSON.stringify(diamondDetails));

        const ringsettinglistlink = ShapeCode?.length > 0 ? `/customize/ring-settings.html?customFilters=shape:${ShapeCode[0]?.code}` : "/customize/ring-settings.html";
        const settinglistlink = ShapeCode?.length > 0 ? `${custmizelink?.setting_link}?customFilters=shape:${ShapeCode[0]?.code}` : `${custmizelink?.setting_link}`;
        const finalproductquery = `${custmizelink?.finalproductlink}.html?rid=${finalsettingid}&did=${finaldiamondid}&prid=${finalproductsettingid}`;

        const isshapeSame = selectedoption_obj?.shape === diamondDetails?.diamond_Shape_code;

        if (step === "Diamond") {
            if (ringsetting) {
                if (isshapeSame) {
                    history.push(finalproductquery);
                } else {
                    history.push(settinglistlink);
                }
            } else {
                history.push(ringsettinglistlink);
            }
        } else {
            if (step === null) {
                localStorage.setItem("step", "Diamond");
                history.push(ringsettinglistlink);
            } else {
                if (ringsetting) {
                    if (isshapeSame) {
                        history.push(finalproductquery);
                    } else {
                        history.push(settinglistlink);
                    }
                }
            }
        }
    }

    renderSlectThisOptionButton = () => {
        return (
            <div className='selectthisoption-buttonwrapper'>
                <button className='selectthisoption-button' onClick={() => this.handleSelectOption()}>
                    <span>select this option</span>
                </button>
            </div>
        )
    }

    renderAddToCartMobile() {
        const isPrerendered = isSSR() || isCrawler();
        const isPrerendered_classname = isPrerendered ? "ProductActions-AddToCartFixed_isPrerendered" : "";

        return (
            <div className={`${isPrerendered_classname} ProductActions-AddToCartFixed`}>
                {this.renderSlectThisOptionButton()}
            </div>
        );
    }

    renderAddToCartActionBlock() {
        const isPrerendered_classname = isSSR() || isCrawler() ? "ProductActions-AddToCartWrapper_isPrerendered" : "";

        return (
            <div
                className={`${isPrerendered_classname} ProductActions-AddToCartWrapper`}
            >
                {this.renderSlectThisOptionButton()}
            </div>
        );
    }

    renderFreeGiftSection() {
        return (
            <FreeGiftOption />
        )
    }

    renderDiamondInformation() {
        const {
            diamond
        } = this.props;

        if (diamond?.length <= 0) {
            return null;
        }

        return (
            <DiamondInfoDetailPage diamond={diamond[0]} />
        )
    }

    renderCertifiedBy() {
        const {
            diamond,
            device: { isMobile }
        } = this.props;

        return (
            <div className="certificate-image-container">
                {
                    diamond?.map((Value, index) => (
                        <>
                            {
                                Value?.cert_url ? <div className="modal-body">
                                    {
                                        Value?.cert_url?.includes(".pdf")
                                            ? <iframe
                                                width="700" height={isMobile ? "300" : "300"}
                                                src={Value?.cert_url}
                                                className="real-view-video"
                                            ></iframe>
                                            : <img
                                                className="img-responsive origin-cart-popup"
                                                src={Value?.cert_url}
                                                alt="Diamond Certificate"
                                            />
                                    }
                                </div> : ""
                            }
                        </>
                    ))
                }
            </div>
        );
    }

    renderContent = () => {
        return (
            <>
                {this.renderDiamondInformation()}
                {this.renderFreeGiftSection()}
                {this.renderAddToCartActionBlock()}
                {this.renderShippingTime()}
            </>
        );
    }

    renderDesktop() {
        return (this.renderContent());
    }

    renderMobile() {
        window.addEventListener('scroll', (event) => {
            if (event.type === "scroll") {
                if (window.scrollY <= 0 || window.scrollY >= 720) {
                    this.setState({
                        scroll: true
                    });
                } else {
                    this.setState({
                        scroll: false
                    });
                }
            }
        });

        return (
            <>
                {this.renderContent()}
                {
                    // this.state.scroll ? this.renderAddToCartMobile() : <></>
                }
            </>
        );
    }

    renderProductDesktopMainData() {
        const {
            isLoading
        } = this.props;

        if (isLoading) {
            return (
                <>
                    {this.renderProductStocknumber()}
                    {this.renderProductName()}
                </>
            )
        }

        return (
            <>
                {this.renderProductStocknumber()}
                {this.renderProductName()}
                {this.onlyOneAvaliable()}
                {this.renderPrice()}
            </>
        );
    }

    renderProductActions() {
        const {
            device: {
                isMobile
            },
            isLoading
        } = this.props;

        return (
            <div className='ProductPage-ProductActions'>
                {this.renderProductDesktopMainData()}

                {!isLoading && (isMobile ? this.renderMobile() : this.renderDesktop())}
            </div>
        );
    }

    renderProductPageContent() {
        const { diamond, isLoading } = this.props;

        if (isLoading) {
            return (
                <>
                    <div className={'product-image-gallery'}>
                        <div className='gallery-image'>
                            {this.renderImagePlaceHolder()}
                        </div>
                    </div>
                    {this.renderProductActions()}
                </>
            )
        }

        return (
            <>
                {
                    diamond?.map((value, index) => (
                        <DiamondImageGallery product={value} key={index} />
                    ))
                }
                {this.renderProductActions()}
            </>
        );
    }

    renderProductDetailsContent = () => {
        const { diamond } = this.props;

        return (
            <div className='DiamondPage-DiamondSpecificationsWrapper'>
                <div className="DiamondPage-ProductSpecifications">
                    <div className="DiamondSpecifications-Tabs">
                        <div className={'DiamondSpecifications-TabsHeading'}>
                            <span>Diamond Details</span>
                        </div>
                    </div>

                    <div className="DiamondSpecifications-TabsDescriptions">
                        <div className={'DiamondSpecifications-TabsDescriptionContent'}>
                            <div className='DiamondSpecifications-ProductDetailsTabs'>
                                <div className='ProductAttributes-AttributeBlockWrapper'>
                                    <div className='ProductAttributes-AttributeBlock'>
                                        <h2 className='ProductAttributes-Group'>Diamond Information</h2>

                                        <DiamondDetailsContent ringdiamond={diamond[0]} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const { diamond, isLoading } = this.props;

        const { ringsetting, ringdiamond } = this.state;

        if (diamond?.length <= 0 && !isLoading) {
            return <NoMatch />
        }

        return (
            <main
                className='ProductPage DiamondPafeDetailsSection'
                aria-label="Product page"
            >
                <StepSection
                    category={"Diamond"}
                    ringdiamond={ringdiamond}
                    ringsetting={ringsetting}
                    hasColor={diamond[0]?.hasColor}
                />

                <ContentWrapper
                    wrapperMix={{ block: 'ProductPage', elem: 'Wrapper' }}
                    label={'Main product details'}
                >
                    {this.renderProductPageContent()}
                </ContentWrapper>

                {diamond?.length > 0 && this.renderProductDetailsContent()}

                {
                    diamond?.length > 0
                        ? <DiamondDetails
                            diamond={diamond}
                        />
                        : ""
                }
            </main>
        );
    }
}

export default ViewDiamondPage;
